// extracted by mini-css-extract-plugin
export default {"SubjectButtons":"subjectButtons_SubjectButtons__5cB2V"};